import { useContext } from 'react'
import { DeskContext } from '#src/contexts/DeskContext.tsx'

export function useIsInDesk(): boolean {
  const { deskId } = useContext(DeskContext)
  return !!deskId
}
